export const ALTOVITA_ECOSTATS_LINK = 'https://www.altovita.com/ecostats'
